import axios from "axios";

export default function HistoriqueCommande(){
    const MagasinId = localStorage.getItem('MagasinId') || '';
    const MagasinName = localStorage.getItem('MagasinName') || '';

    const safeName = MagasinName ? encodeURIComponent(MagasinName) : (MagasinId ? String(MagasinId) : 'magasin');
    const safeId = MagasinId ? String(MagasinId) : '';

    const urlShowProduct = safeId 
        ? `${process.env.REACT_APP_PHP_APP_URL}/historiques/${safeName}/${safeId}`
        : `${process.env.REACT_APP_PHP_APP_URL}/historiques/${safeName}`;
    const urlShowProductAdmin = `${process.env.REACT_APP_PHP_APP_URL}/admin/historiques`;

    const getCommande=()=>{
        return (axios.post(urlShowProduct));
    }
    const getCommandeAdmin=()=>{
        return (axios.post(urlShowProductAdmin));
    }
    return {
        getCommande,
        getCommandeAdmin,
    }
}